import { RoutePoint } from "./routePoint";

export const CheckListId = {
    GOZ_Loading: "GOZ_Погрузка",
    GOZ_Unloading: "GOZ_Разгрузка",
    GOZ_Return: "GOZ_Возврат",
    SBL_Route: "SBL_Маршрут",
    Bicycles_Loading: "Велосипеды_Пог��узка",
    Bicycles_CFZ: "Велосипеды_ЦФЗ",
    SingleOrder_Loading: "Один_Заказ_Погрузка",
    SingleOrder_Unloading: "Один_Заказ_Разгрузка",
};

export const FLEXIBLE_ORDER_CHECKLISTS = [CheckListId.SBL_Route];

// Точки представляемые заказами с таким чеклистом можно проходить в произвольном порядке, после забора на первой точке
export const isFlexibleOrderCheckList = (routePoint: RoutePoint): boolean =>
    !routePoint.checkListId || FLEXIBLE_ORDER_CHECKLISTS.includes(routePoint.checkListId);
